import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {AlertListService} from '@xref/ngx';
import {ElementHelperService} from '../../services/element-helper/element-helper.service';
import {StylingCheckService} from '../../services/styling-check/styling-check.service';
import {IdService} from '../../services/id/id.service';
import {PermissionsService} from "src/app/services/permissions/permissions.service";

@Component({
    selector: 'xlog-forgotten-password',
    templateUrl: './forgotten-password.component.pug',
    styleUrls: ['./forgotten-password.component.scss'],
    standalone: false
})
export class ForgottenPasswordComponent implements OnInit, AfterViewInit {
    @ViewChild('formRef', {static: true}) form: any;

    loaded = false;
    model = { email: '' };

    constructor(
        private id: IdService,
        private alertList: AlertListService,
        private router: Router,
        private el: ElementHelperService,
        private stylingCheckService: StylingCheckService,
        private featureFlagService: PermissionsService
    ) {}

    ngOnInit() {
        this.loaded = true;
        this.stylingCheckService.setClassic(false);
    }

    ngAfterViewInit() {
        this.el.focusById('email');
    }

    resetPasswordSuccess = (data: any) => {
        if (data.message === 'User inactive.') {
            this.alertList.append([{ active: true, type: 'danger', messageKey: 'alerts.auth.XREF_USER_INACTIVE'}]);
        } else {
            this.alertList.append([
                {
                    active: true,
                    type: 'success',
                    messageKey: 'alerts.forgottenPassword.resetEmailSuccess',
                    messageParameters: {
                        email: this.model.email
                    },
                    keepOnRouteChange: true,
                }
            ]);
            this.router.navigate(['login']);
        }

        this.loaded = true;
    };

    resetPasswordError = (error: any) => {
        const errors = <any>[];
        if (error.hasOwnProperty('status_message') && error.status_message === 'maintenance_omni') {
            errors.push({ active: true, type: 'danger', messageKey: 'alerts.auth.MAINTENANCE_OMNI' });
        } else if (error.hasOwnProperty('data') && error.data.xref_error === 'XREF_USER_IS_INACTIVE') {
            error.push({ active: true, type: 'danger', messageKey: `alerts.auth.${error.data.xref_error}` });
        } else {
            errors.push({active: true, type: 'danger', messageKey: 'alerts.generic.error'});
        }
        this.alertList.append(errors);
        this.loaded = true;
    };

    resetPassword() {
        this.loaded = false;
        this.id.requestResetPasswordLink(
            this.model,
            this.resetPasswordSuccess,
            this.resetPasswordError,
        );
    }
}
